import Container from './Container'

const QBODataGrid = ({zoomLevel}) => {
  return (
    <Container zoomLevel={zoomLevel}/>
  )
}

export default QBODataGrid